import {
  apiUrl,
  disableRbac,
  entraAuthority,
  entraClientId,
  entraRedirectUri,
  entraScopes,
  featureEnableEquipmentWatchlist,
  mode,
} from 'importMeta';

export default function getConfig() {
  let config = window['__APP_CONFIG__'];

  if (!config) {
    if (mode() === 'development') {
      config = {
        apiUrl: apiUrl(),
        appInsightsConnectionString: '',
        appInsightsKey: '',
        disableRbac: disableRbac(),
        entraAuthority: entraAuthority(),
        entraClientId: entraClientId(),
        entraRedirectUri: entraRedirectUri(),
        entraScopes: entraScopes(),
        featureEnableEquipmentWatchlist: featureEnableEquipmentWatchlist(),
        mode: 'local',
        nonProductionMode: true,
      };
    } else {
      config = window['__APP_CONFIG__'] = {
        apiUrl: '',
        appInsightsConnectionString: '',
        appInsightsKey: '',
        disableRbac: false,
        entraAuthority: '',
        entraClientId: '',
        entraRedirectUri: '',
        entraScopes: [],
        featureEnableEquipmentWatchlist: true,
        mode: '',
        nonProductionMode: false,
      };
    }
  }

  return config;
}
